"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../model/types");
var ErrorValidator;
(function (ErrorValidator) {
    ErrorValidator["invalid_arguments"] = "invalid_arguments";
})(ErrorValidator || (ErrorValidator = {}));
/**
 * Validation decorator.
 *
 * @param {ValidatorArgumentType[]} types         Array of types of decorated function arguments.
 */
function Validate() {
    var types = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
    }
    return function (target, propertyKey, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!Validator.validateArguments(arguments, types)) {
                throw new TypeError(ErrorValidator.invalid_arguments);
            }
            return originalMethod.apply(this, args);
        };
        // return newDesc;
    };
}
exports.Validate = Validate;
var Validator = /** @class */ (function () {
    function Validator() {
    }
    Validator.validateArguments = function (args, types) {
        if (args.length !== types.length) {
            return false;
        }
        for (var i = 0; i < args.length; i += 1) {
            var arg = args[i];
            if (typeof types[i] === types_1.Type.function) {
                var constructor = types[i];
                if (!Validator.validateObject(arg, constructor)) {
                    return false;
                }
            }
            else if (typeof types[i] === types_1.Type.object) {
                var validationTuple = types[i];
                if (!Validator.validateArray(arg, validationTuple[1])) {
                    return false;
                }
            }
            else {
                if (typeof arg !== types[i]) {
                    return false;
                }
            }
        }
        return true;
    };
    Validator.getConstructorName = function (construct) {
        var funcNameRegex = /function (.{1,})\(/;
        var results = (funcNameRegex).exec(construct.toString());
        return (results && results.length > 1) ? results[1] : '';
    };
    Validator.validateObject = function (object, typeConstructor) {
        var type = new typeConstructor();
        var isValid = true;
        if (typeof object !== types_1.Type.object) {
            return false;
        }
        Object.keys(type).forEach(function (key) {
            if (type[key] !== null && typeof type[key] !== typeof object[key]) {
                isValid = false;
            }
        });
        return isValid;
    };
    Validator.validateArray = function (array, ofType) {
        if (!Array.isArray(array)) {
            return false;
        }
        if (array.length > 0) {
            for (var i = 0; i < array.length; i++) {
                var el = array[i];
                if (typeof ofType === types_1.Type.string) {
                    if (!Validator.validateStringType(el, ofType)) {
                        return false;
                    }
                }
                else if (typeof ofType === types_1.Type.function) {
                    if (!Validator.validateObject(el, ofType)) {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    Validator.validateStringType = function (val, type) {
        return typeof val === type;
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/modules/validator.js
// module id = 9
// module chunks = 0